import { Fragment } from "react";
import { GetItemReturnArr } from "./SpecificationGeneral"
import styles from './SpecificationPanel.module.scss'

type IncomingType = {
    arrLine: GetItemReturnArr[];
    windowDebug: boolean;
};

export const LineForSpecificationGeneral = ({ arrLine, windowDebug }: IncomingType) => {
    return (
        <>
            {
                arrLine.map(line => (
                    <Fragment key={`${line.name}_fragment`}>
                        <div key={`${line.name}_name`} className={styles.specificationGeneral_title}>{line.name}</div>
                        <div key={`${line.name}_count`}>{line.count} шт.</div>
                        {windowDebug && <Fragment key={`${line.name}_fragmentWindowDebug`}>
                            <div key={`${line.name}_price`}>{line.price}</div>
                            <div key={`${line.name}_totalPrice`}>{line.totalPrice}</div>
                        </Fragment>}
                    </Fragment>
                ))
            }
        </>
    )
}
